import type {
  Components,
  PaletteColor,
  PaletteColorChannel,
  Theme,
} from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import type { ColorName } from "../../options/palette";

const BACKGROUND_ALPHA = 0.9;

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      fontSize: "0.75rem",
      lineHeight: "1rem",
      padding: "0.25rem 1rem",
      borderRadius: 0,
      fontWeight: 500,

      "&.MuiTooltip-tooltipPlacementBottom:not(.MuiTooltip-tooltipArrow)": {
        marginTop: theme.spacing(0.5),
      },

      variants: [
        ...Object.entries(theme.palette)
          .filter(
            ([color, values]) =>
              color !== "error" &&
              typeof values === "object" &&
              "main" in values &&
              "contrastText" in values
          )
          .map(([color, values]: [ColorName, PaletteColor]) => {
            const cssColors = theme.vars?.palette[color] as
              | PaletteColorChannel
              | undefined;

            return {
              props: {
                color,
              },
              style: {
                backgroundColor: cssColors
                  ? `rgba(${cssColors.mainChannel} / ${BACKGROUND_ALPHA})`
                  : alpha(values.main, BACKGROUND_ALPHA),
                color: (theme.vars ?? theme).palette[color].contrastText,

                "& .MuiTooltip-arrow": {
                  color: cssColors
                    ? `rgba(${cssColors.mainChannel} / ${BACKGROUND_ALPHA})`
                    : alpha(values.main, BACKGROUND_ALPHA),
                },
              },
            };
          }),
        {
          props: {
            color: "error",
          },
          style: {
            backgroundColor: theme.palette.error.light,
            border:
              "100" in theme.palette.error
                ? `1px solid ${theme.palette.error[100]}`
                : undefined,
            color:
              "A700" in theme.palette.error
                ? theme.palette.error.A700
                : theme.palette.error.dark,

            "& .MuiTooltip-arrow": {
              color: theme.palette.error.light,
            },
          },
        },
      ],
    }),
  },
};
